module.exports = __webpack_public_path__ + "img/scan_ranking_two.a5415d02.png";